/* eslint-disable @typescript-eslint/naming-convention */
import { remove } from '@core/api/baseApi';
import { DeleteOrganizationTemplateResponse } from '@core/types/ApiResponses';

const deleteOrganizationTemplate = (templateId: string): Promise<DeleteOrganizationTemplateResponse> =>
  remove(`/organizations/templates/${templateId}`);

export { deleteOrganizationTemplate };
